<template>
  <div class="city-dorms section">
    <div class="city-dorms-bg">
      <img src="@/assets/img/shapes/shape-9.svg" alt="yurtlar burada" class="shape-9">
      <img src="@/assets/img/shapes/shape-10.svg" alt="yurtlar burada" class="shape-10">
    </div>
    <container>
      <div class="city-dorms__wrp">
        <div class="city-dorms__cnt">
          <img src="@/assets/img/building.svg" alt="" class="city-dorms__icon">
          <div class="city-dorms__title color-white">
            <span class="d-block color-purple">
              Şehirlere Göre
            </span>
            Yurt Listeleri
          </div>
          <div class="city-dorms__txt text color-white cropDesktop" v-if="settings">
            {{ settings.setting.city_section_spot }}
          </div>

          <div class="city-dorms__txt text color-white cropMobile" v-if="settings">
            {{ settings.setting.city_section_spot | truncate(100)  }}
          </div>

          <div class="city-dorms-inf">
            <div class="city-dorms-inf__title" v-if="settings">
              <strong>{{ settings.dorms }}</strong>
              Aktif Yurt
            </div>

            <v-link
              class="button--more color-purple"
              title="Tümünü Gör"
              icon="icon-arrow-long-right"
              icon-position="right"
              :to="{ name: 'CityList' }"
            />
          </div>
        </div>

        <div class="city-dorms-slider sliderMobile">
        <swiper :options="swiperOption">
          <swiper-slide
            v-for="city in cities"
            :key="city.id"
            class="featured-dorms__col">
            <CityCard
              :city="city"
            />
          </swiper-slide>
          <div class="swiper-paginations" style="text-align: center;" slot="pagination"></div>
        </swiper>
        </div>

        <div class="city-dorms-slider sliderDesktop">
          <CityCard
            v-for="(city, $index) in cities"
            :key="city.id"
            :class="{ premium : $index === 0 }"
            :city="city"
          />
        </div>
      </div>
    </container>
    <div class="city-dorms__bottom">
      <img src="@/assets/img/shapes/shape-4.svg" alt="" class="shape-4">
      <div class="city-dorms-ctr">
        <img src="@/assets/img/shapes/shape-5.svg" alt="" class="shape-5">
        <div class="shapes-6">
          <img src="@/assets/img/shapes/shape-6.svg" alt="" class="shape-6">
        </div>

        <div class="city-dorms-ctr__cnt">
          <img src="@/assets/img/pin-navy.svg" alt="" class="city-dorms-ctr__img">
          <router-link :to="{ name: 'Notice' }" class="city-dorms-ctr__btn">
            <div class="btn-txt">Yurtlara Özel İlanlar</div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CityCard from '@/components/CityCard'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'CityDorms',
  components: {
    CityCard
  },
  data () {
    return {
      cities: [],
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 20,
        slidesPerGroup: 2,
        breakpoints: {
          576: {
            slidesPerView: 1,
            centeredSlides: false,
            slidesPerGroup: 1
          },
          320: {
            slidesPerView: 1
          }
        },
        pagination: {
          el: '.swiper-paginations',
          clickable: true
        }
      }
    }
  },
  methods: {
    getCities () {
      let self = this
      axios.get('/site/home/cities?take=5')
        .then(response => {
          self.cities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },
  computed: {
    ...mapGetters(['settings'])
  },
  created () {
    this.getCities()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/components/city-dorms";
</style>
